export const TOASTER_TYPES = {
	DEFAULT: 'default',
	INFO: 'info',
	SUCCESS: 'success',
	WARNING: 'warning',
	ERROR: 'error',
};
